module.exports = __webpack_public_path__ + "static/media/thyssen-bornemisza-museo-nacional.e53b1ef8.svg";